import { BankHourHistoryType } from '../../models/bank-hour';
import { BankHourRequestStatus } from '../../models/bank-hours-request';

export const BankHourRequestStatusHumanized = {
  [BankHourRequestStatus.PENDING]: 'Pendente',
  [BankHourRequestStatus.REPROVED]: 'Reprovado',
  [BankHourRequestStatus.RH_APPROVED]: 'Aprovado pelo RH',
  [BankHourRequestStatus.SUPERVISOR_APPROVED]: 'Aprovado pelo supervisor',
  [BankHourRequestStatus.CANCELED]: 'Cancelada',
};

export const BankHourRequestStatusColor = {
  [BankHourRequestStatus.PENDING]: '#f7cb7340',
  [BankHourRequestStatus.REPROVED]: '#ff00002b',
  [BankHourRequestStatus.RH_APPROVED]: '#40ff0050',
  [BankHourRequestStatus.SUPERVISOR_APPROVED]: '#64d8ff32',
  [BankHourRequestStatus.CANCELED]: '#9e9e9e30',
};

export const bankHourRequestStatusList = [
  {
    value: BankHourRequestStatus.PENDING,
    label: 'Pendente',
  },
  {
    value: BankHourRequestStatus.REPROVED,
    label: 'Reprovado',
  },
  {
    value: BankHourRequestStatus.RH_APPROVED,
    label: 'Aprovado pelo RH',
  },
  {
    value: BankHourRequestStatus.SUPERVISOR_APPROVED,
    label: 'Aprovado pelo supervisor',
  },
  {
    value: BankHourRequestStatus.CANCELED,
    label: 'Cancelada',
  },
];

export const BankHourHistoryTypeHumanized = {
  [BankHourHistoryType.ENTRY]: 'Entrada',
  [BankHourHistoryType.EXIT]: 'Saída',
};
